import axios, { AxiosError } from 'axios';
import { getLogger } from '../diagnostics/logger';
import { getSimManagementErrorFromAxiosError } from '.';
import { ProductOrder } from '../models/state/bucket';

import config from '../config';
const log = getLogger('simManagement.api.orangeProvisioningOrderApi');

export function get(serialNo: string): Promise<ProductOrder> {
  const url = config.API_BASE_URL + `api/sim/${serialNo}/orangeProvisioningOrder`;
  return new Promise<ProductOrder>((resolve, reject) => {
    axios
      .get(url)
      .then((response: any) => {
        const result = response.data;
        resolve(result);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error(`Failed to load orange provisioning order by tel ${serialNo}.`, simManagementError);
        reject(simManagementError);
      });
  });
}
